import backend from '@common/backend';

const BASE = '/userOnboardingQuizzes';

export const getUserOnboardingQuizzes = async (query?: any) =>
	backend.get(`${BASE}/`, {
		params: {
			...query,
		},
	});

export const getUserOnboardingQuizz = async (id: number) => backend.get(`${BASE}/${id}`);

export const getUserOnboardingQuizzByUserId = async (userId: any, query?: any) =>
	backend.get(`${BASE}/user/${userId}`, {
		params: {
			...query,
		},
	});
